import { ICuocThaoLuanComment } from "../models/response/cuoc-thao-luan/ICuocThaoLuanComment";
import { ICuocThaoLuanReaction } from "../models/response/cuoc-thao-luan/ICuocThaoLuanReaction";
import { apiClient } from "./apiClient";

export const cuocThaoLuanApi = {
    loadStart: (id: number) => apiClient.get(`cuoc-thao-luan/${id}`),
    loadComment: (id: number) => apiClient.get(`cuoc-thao-luan/${id}/comment`),
    loadReaction: (id: number) => apiClient.get(`cuoc-thao-luan/${id}/reaction`),
    addComment: (data: ICuocThaoLuanComment) => apiClient.post(`cuoc-thao-luan/${data.sis_cuoc_thao_luan_id}/comment`, data),
    removeComment: (id: number) => apiClient.delete(`cuoc-thao-luan/comment/${id}`),
    addReaction: (data: ICuocThaoLuanReaction) => apiClient.post(`cuoc-thao-luan/${data.sis_cuoc_thao_luan_id}/reaction`, data),
    removeReation: (id: number) => apiClient.delete(`cuoc-thao-luan/reaction/${id}`),
}